// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"AddingEntityBox__wrapper___2r-jV","title":"AddingEntityBox__title___229KH"};